// extracted by mini-css-extract-plugin
export default {"loginText":"NeedToLogin_loginText__ZbGYD","modalOverlay":"NeedToLogin_modalOverlay__jHLDM","modalContent":"NeedToLogin_modalContent__JYdOE"};